<div class="section-header">
  <div class="title">{{ title }}</div>
</div>
